import {
  BankNoteIncrease,
  CoinsStacked03,
} from '@branch-messenger/willow-ui/icons'

import { DebitCardType } from '@/types/card'

export const useConnectedCardInfo = (type: DebitCardType) => {
  const title = type === 'PAYOUT_CARD' ? 'Payouts' : 'On-Demand Pay'
  const icon = type === 'PAYOUT_CARD' ? CoinsStacked03 : BankNoteIncrease
  const missingCardDescription =
    type === 'PAYOUT_CARD'
      ? `You're not using a debit card for your payouts. If you connect a debit card to your account for payouts, it will appear here.`
      : `You haven't taken an advance directly to a debit card yet. Once you do, your connected debit card will appear here.`

  return { title, missingCardDescription, icon }
}
